import axios from "axios";
import qs from "qs";
import _this from "../router";
import { WebSiteName, InitDefaultPostParams } from "../webname.js";
//import httpAjax    from "./httpAjax.js";

//axios.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded";
//axios.defaults.headers.get["Content-Type"] = "application/x-www-form-urlencoded";
//axios.defaults.withCredentials = true;

/***********
新部署需要设置以下值：
***********/
//如果在内外网内外都有用户，则设置下面两个值：
let checkLocalInsideUrl = ""; //http://10.183.105.114  自动检查是否处于内网
let checkLocalInsideFlagStr = "教育云系统维护公告"; //内网访问checkLocalInsideUrl 时，如果能够打开页面，且页面内包含该字符串，则认为用户处于内网


//defaultPriviteApiHost: 默认的private-api服务器地址。 页面首次导入时，使用这个接口地址，获取
let defaultPriviteApiHost = "http://heze.91cb.net/private-api";
let mainHostName = "heze.91cb.net";
let useSubSiteHost = false; //是否使用二级域名， 如果使用二级域名，则要求部署必须有独立域名。子网站url格式为  "http://subsitename.[mainHostName]"
                           //如果不使用二级域名， 则子网站url格式为 "http://[mainHostName]/subsitename"
let autoFindPriviteApiHost = false; //如果设为true， 则自动根据访问的url，将url的二级域名替换为 private-api，作为private-api服务器地址

//urls: 页面跳转地址： 通过服务器获取
/*
let gWebHostArr = { //if (useSubSiteHost)
  "private-api": defaultPriviteApiHost,
  "www"         : "http://"         +mainHostName+"/", // 主站
  "school"      : "http://school."      +mainHostName+"/", // 学校空间
  "school-admin": "http://school-admin."+mainHostName+"/", // 学校后台
  "eduyun"      : "http://eduyun."      +mainHostName+"/", // 教育云
  "edu-admin"   : "http://edu-admin."   +mainHostName+"/", // 教育云后台

  "class"       : "http://class."       +mainHostName+"/", // 班级空间
  "student"     : "http://student."     +mainHostName+"/", // 学生空间
  "teacher"     : "http://teacher."     +mainHostName+"/", // 教师空间
  "researcher"  : "http://researcher."  +mainHostName+"/", // 教研员空间

  "reg"         : "http://reg."         +mainHostName+"/", // 注册
  "login"       : "http://login."       +mainHostName+"/", // 登录
//"passport"    : "http://passport.rizhaojiaoyu.cn/cbweb/index.php/index/login/password.html", //找回密码
  "config"      : "http://config."      +mainHostName+"/", //配置文件
  "help"        : "http://help."        +mainHostName+"/", //帮助站点
  "download"    : "http://www."         +mainHostName+"/download", //客户端下载页
  "static-resource": "http://static-resource." +mainHostName+"/", //静态资源站点
  "weblive"     : "http://weblive.rizhaojiaoyu.cn/live/index/web_live_list", //活动直播
  "tiku"        : "http://tiku."        +mainHostName+"/", //题库网站

  "article"     : "http://article."     +mainHostName+"/", // 资源详情
  "group"       : "http://group."       +mainHostName+"/", // 协作组，专题工作
  "zhanping"    : "http://zhanping."    +mainHostName+"/", // 展评
  "record-embedpage": "http://record-embedpage." +mainHostName+"/", // 录播内嵌页

  "flv": "http://srs.rizhaojiaoyu.cn:8320/live/product;http://srs.rizhaojiaoyu.cn:8330/live/product;http://srs.rizhaojiaoyu.cn:8340/live/product;http://srs.rizhaojiaoyu.cn:8350/live/product;http://srs.rizhaojiaoyu.cn:8360/live/product;http://srs.rizhaojiaoyu.cn:8370/live/product", // 互动课堂、学校电视台、会议直播  直播地址。 需要增加后缀：".flv"
  "flv-village": "http://srs.rizhaojiaoyu.cn:8320/live/village;http://srs.rizhaojiaoyu.cn:8330/live/village;http://srs.rizhaojiaoyu.cn:8340/live/village;http://srs.rizhaojiaoyu.cn:8350/live/village;http://srs.rizhaojiaoyu.cn:8360/live/village;http://srs.rizhaojiaoyu.cn:8370/live/village;", // 专递课堂、视频会议、录播盒子 等带有互动性质的 直播地址。 需要增加后缀：".flv"
  "flv-village-sub": "http://srs.rizhaojiaoyu.cn:8320/live/village-sub;http://srs.rizhaojiaoyu.cn:8330/live/village-sub;http://srs.rizhaojiaoyu.cn:8340/live/village-sub;http://srs.rizhaojiaoyu.cn:8350/live/village-sub;http://srs.rizhaojiaoyu.cn:8360/live/village-sub;http://srs.rizhaojiaoyu.cn:8370/live/village-sub;", // 专递课堂的学生端直播地址。 需要增加后缀：".flv"
  //不再使用 rtmp直播地址
  
  "upload": "http://upload.rizhaojiaoyu.cn:8531/upload", // 文件上传地址
  "fileview": "http://fileview.rizhaojiaoyu.cn:8620/onlinePreview?url=;http://fileview.rizhaojiaoyu.cn:8630/onlinePreview?url=", //文档预览地址
  "fileview-url-host": "", //为使fileview服务器能正常访问要预览的url文档，将这些host替换成下面的host
  "fileview-url-host-replace": "",

  //日照新专区：只在日照教育云设置这些项
  "rizhao_edu_home"          : "http://www."            +mainHostName+"/", // 日照新首页
  "rizhao_jiaoyuxinxihua"    : "http://jiaoyuxinxihua." +mainHostName+"/", // 教育信息化专区
  "rizhao_anquanjiaoyu"      : "http://anquanjiaoyu."   +mainHostName+"/", // 安全教育专区
  "rizhao_dangjian"          : "http://dangjian."       +mainHostName+"/", // 党建专区
  "rizhao_jiaoxuekeyan"      : "http://jiaoxuekeyan."   +mainHostName+"/", // 教育科研专区
  "rizhao_jiaoyuguanli"      : "http://jiaoyuguanli."   +mainHostName+"/", // 教育管理专区
  "rizhao_yiqingfangkong"    : "http://yiqingfangkong." +mainHostName+"/", // 疫情防控专区
  "rizhao_xianshangjiaoxue"  : "http://xianshangjiaoxue."   +mainHostName+"/", // 线上教学专区
  "rizhao_suzhijioayu"       : "http://suzhijioayu."        +mainHostName+"/", // 素质教育专区
  "rizhao_shuangjianzengxiao": "http://shuangjianzengxiao." +mainHostName+"/", // 双减增效专区
};
*/

//if !(useSubSiteHost)
// 注意还需要修改每个项目下的 .env文件，设置 USE_SUBSITE=0
let gWebHostArr = {  
  "private-api": defaultPriviteApiHost,
  "www"         : "http://"+mainHostName+"/", // 主站
  "school"      : "http://"+mainHostName+"/school/", // 学校空间
  "school-admin": "http://"+mainHostName+"/school-admin/", // 学校后台
  "eduyun"      : "http://"+mainHostName+"/eduyun/", // 教育云
  "edu-admin"   : "http://"+mainHostName+"/edu-admin/", // 教育云后台

  "class"       : "http://"+mainHostName+"/class/", // 班级空间
  "student"     : "http://"+mainHostName+"/student/", // 学生空间
  "teacher"     : "http://"+mainHostName+"/teacher/", // 教师空间
  "researcher"  : "http://"+mainHostName+"/researcher/", // 教研员空间

  "reg"         : "http://"+mainHostName+"/reg/", // 注册
  "login"       : "http://"+mainHostName+"/login/", // 登录
//"passport"    : "http://"+mainHostName+"/passport", //找回密码
  "config"      : "http://"+mainHostName+"/config/", //配置文件
  "help"        : "http://"+mainHostName+"/help/", //帮助站点
  "download"    : "http://"+mainHostName+"/download", //客户端下载页
  "static-resource": "http://"+mainHostName+"/static-resource/", //静态资源站点
  "weblive"     : "http://"+mainHostName+"/weblive", //活动直播
  "tiku"        : "http://"+mainHostName+"/tiku/", //题库网站

  "article"     : "http://"+mainHostName+"/article/", // 资源详情
  "group"       : "http://"+mainHostName+"/group/", // 协作组，专题工作
  "zhanping"    : "http://"+mainHostName+"/zhanping/", // 展评
  "record-embedpage": "http://"+mainHostName+"/record-embedpage/", // 录播内嵌页

  "flv": "http://srs.rizhaojiaoyu.cn:8320/live/product;http://srs.rizhaojiaoyu.cn:8330/live/product;http://srs.rizhaojiaoyu.cn:8340/live/product;http://srs.rizhaojiaoyu.cn:8350/live/product;http://srs.rizhaojiaoyu.cn:8360/live/product;http://srs.rizhaojiaoyu.cn:8370/live/product", // 互动课堂、学校电视台、会议直播  直播地址。 需要增加后缀：".flv"
  "flv-village": "http://srs.rizhaojiaoyu.cn:8320/live/village;http://srs.rizhaojiaoyu.cn:8330/live/village;http://srs.rizhaojiaoyu.cn:8340/live/village;http://srs.rizhaojiaoyu.cn:8350/live/village;http://srs.rizhaojiaoyu.cn:8360/live/village;http://srs.rizhaojiaoyu.cn:8370/live/village", // 专递课堂、视频会议、录播盒子 等带有互动性质的 直播地址。 需要增加后缀：".flv"
  "flv-village-sub": "http://srs.rizhaojiaoyu.cn:8320/live/village-sub;http://srs.rizhaojiaoyu.cn:8330/live/village-sub;http://srs.rizhaojiaoyu.cn:8340/live/village-sub;http://srs.rizhaojiaoyu.cn:8350/live/village-sub;http://srs.rizhaojiaoyu.cn:8360/live/village-sub;http://srs.rizhaojiaoyu.cn:8370/live/village-sub", // 专递课堂的学生端直播地址。 需要增加后缀：".flv"
  //不再使用 rtmp直播地址
  
  "upload": "http://upload.rizhaojiaoyu.cn:8531/upload", // 文件上传地址
  "fileview": "http://fileview.rizhaojiaoyu.cn:8620/onlinePreview?url=;http://fileview.rizhaojiaoyu.cn:8630/onlinePreview?url=", //文档预览地址
  "fileview-url-host": "", //为使fileview服务器能正常访问要预览的url文档，将这些host替换成下面的host
  "fileview-url-host-replace": "",


  //日照新专区：只在日照教育云设置这些项
  "rizhao_edu_home"          : "http://"+mainHostName+"/", // 新首页
  "rizhao_jiaoyuxinxihua"    : "http://"+mainHostName+"/jiaoyuxinxihua/", // 教育信息化专区
  "rizhao_anquanjiaoyu"      : "http://"+mainHostName+"/anquanjiaoyu/", // 安全教育专区
  "rizhao_dangjian"          : "http://"+mainHostName+"/dangjian/", // 党建专区
  "rizhao_jiaoxuekeyan"      : "http://"+mainHostName+"/jiaoxuekeyan/", // 教育科研专区
  "rizhao_jiaoyuguanli"      : "http://"+mainHostName+"/jiaoyuguanli/", // 教育管理专区
  "rizhao_yiqingfangkong"    : "http://"+mainHostName+"/yiqingfangkong/", // 疫情防控专区
  "rizhao_xianshangjiaoxue"  : "http://"+mainHostName+"/xianshangjiaoxue/", // 线上教学专区
  "rizhao_suzhijioayu"       : "http://"+mainHostName+"/suzhijioayu/", // 素质教育专区
  "rizhao_shuangjianzengxiao": "http://"+mainHostName+"/shuangjianzengxiao/", // 双减增效专区
};

let gWebDeployConst = {
    //无需从private-api下载的常量，但是每个部署可能不同
    "url_heze_specalcolumn_little_writers": "http://heze.91cb.net/school/home?schoolid=11357", //菏泽小作家协会
    "url_rizhao_keepstudy2020": "http://rizhao.91cb.net:8090", //日照不停学
    "url_mudan_keepstudy2020": "http://mudan.91cb.net", //菏泽不停学
    "url_zhaoyang_e_course": "http://zhaoyang.rizhaojiaoyu.cn/", //朝阳e课
    "url_subject_declare": "http://subject-declare.rizhaojiaoyu.cn/", //课题申报
    
    "url_install_file": "http://www.91cb.net/_client_config/installfile.php", //安装文件下载，携带参数： cl
}

let gWebsiteSessionInfo = {
  //登录人信息：每次打开新页面，从网站获取
  logined: false,
  userid: "1", //登录人id  服务器接口要求该值必须填写，此处在未登录时，填1
  sessionKey: "",
  userIdentity: 0, //登录人身份 1=学生 2=教师 4=教研员空间
  userIdentityStatus: 0,
  userName: "", //登录人名字
  userFace: "", //登录人头像
  userSchoolID: "0",
  userEduCityID: "0",
  userEduCountyID: "0",
  userSchoolClassID: "0",
  userAdminList: "",
  ownerID: getUrlParam("userid"),

  //当前页面站点信息
  webSiteStyleTheme: "style2", //网站风格模版
  webSiteLevel: 0, //获取当前页面的信息，用于显示
  webSiteSchoolID: "0",
  webSiteCityEduID: "0",
  webSiteCountyEduID: "0",
  webSiteEduID: getUrlParam("edu_id"),
  webSiteDocumentTitle: "", //用于显示title
  webSiteTitle: "", //网站名：教育云名，学校名
  webSiteLogo: "", //用于显示 logo
  webSiteCityName: "", //用于显示顶部的主站连接
  webSiteCountyName: "", //用于显示顶部的区县连接
  webSiteSchoolName: "", //用于显示顶部的所属学校连接
  webSiteCityDomain: "",
  webSiteCountyDomain: "",
  webSiteSchoolDomain: "",
  webSiteICP: "鲁ICP备09067315号-3",
  webSiteNeedLogin: false, //需要登录才能查看文章详情页面

  //初始化标识，在GetWebInfoAndUserSessionInfoFromServer执行完毕后被设置为true
  hasInited: 0,
  
  //其他
  isLocalNetInSide: "false", //是否在教育局内网：如果是，则内网用户访问资源文件、直播时，使用内网ip，同时外网用户使用外网域名
};

/**********
函数
**********/
function getUrlParam(variable) {
   var query = window.location.search.substring(1);
   var vars = query.split("&");
   for (var i=0;i<vars.length;i++) {
           var pair = vars[i].split("=");
           if(pair[0] == variable){return pair[1];}
   }
   return(false);
}

function isInLocalNet() {
  if (gWebsiteSessionInfo.isLocalNetInSide == "true") {
    return "true";
  }
  return localStorage.getItem("isLocalNetInSide");
}

function randomNum(minNum,maxNum){ 
    let ret = 0;
    switch(arguments.length){ 
        case 1:  //取 [0-minNum] 之间的数
            ret = Math.round(Math.random()*minNum); //parseInt  Math.floor() 结果都是向下取整  round四舍五入
            break; 
        case 2: 
            ret = Math.round(Math.random()*(maxNum - minNum)+minNum); 
            break; 
    } 
    console.log("randomNum minNum:" + minNum+ ", maxNum="+maxNum+ ", ret="+ret);
    return ret;
}

export default {
  useSubSiteHost, //是否使用二级域名访问子站点（否则使用子目录）  
  gWebsiteSessionInfo,
  
  //常用函数
  IsInsideNetUrl(url){      
      return url.indexOf(mainHostName) >= 0;
  },
  
  //获取连接地址
  GetWebHost(hostName) {
    return gWebHostArr[hostName];
  },
  GetRandOneWebHost(hostName){
    let host = this.GetWebHost(hostName);
    if (host) {
      let arr_host = host.split(";");
      let index = randomNum(arr_host.length - 1);
      
      console.log("GetRandOneWebHost host:" + host+ ", length=" +arr_host.length+", index="+index);
      return arr_host[index];
    }
    return "";
  },
  GetWebDeployConst(paramname) {
    return gWebDeployConst[paramname];
  },
  
  GetUserID() {
    return gWebsiteSessionInfo.userid;
  },
  GetEduID() {
    let eduid = _this.app._route.query.edu_id;
    if (!eduid) {
      eduid = gWebsiteSessionInfo.webSiteEduID;
    }
    return eduid;
  },
  GetSchoolID() {
    let schoolid = _this.app._route.query.schoolid;
    if (!schoolid) {
      schoolid = gWebsiteSessionInfo.webSiteSchoolID;
    }
    return schoolid;
  },

  GetWebLevel() {
    return gWebsiteSessionInfo.webSiteLevel;
  },

  IsLogIned() {
    //在同一浏览器打开多个tab页面时，如果其中一个tab页退出登录或登录为其他帐号，
    //其他tab页使用localStorage:loginUserID可获知本页面是否还处于登录状态
    if (!gWebsiteSessionInfo.logined) {
      return false;
    }
    let localUserID = localStorage.getItem("loginUserID");
    if (!localUserID) {
      return false;
    }
    return gWebsiteSessionInfo.userid == localUserID;
  },

  // 这个接口调用必须在其他所有接口调用之前完成
  GetWebInfoAndUserSessionInfoFromServer(asyncCall) {
    this.checkLocalNet();
    let id = getUrlParam("userid") == undefined ? 1 : getUrlParam("userid");
    //只有这个接口使用同步调用
    var data = {
      s: "Common.WebTop.GetWebInfoAndUserSesstionInfo",
      website: WebSiteName,
      url: window.location.href, //服务器需要根据此url，分析，得到各参数，以得到其所代表的的具体功能
      userid: id,
    };

    //获取首次访问使用的private-api服务器地址
    let urlApi = defaultPriviteApiHost;

    if (autoFindPriviteApiHost){
        if (useSubSiteHost){
            let arr_host = location.host.split(".");
            if (arr_host.length > 2){
                arr_host[0] = "private-api";
                let host = arr_host.join(".");
                urlApi = location.protocol + "//" + host;
            }
            else{
                let host = "private-api." + location.host;
                urlApi = location.protocol + "//" + host;
            }
        }
        else{
            urlApi = location.protocol + "//" + location.host + "/private-api";
        }
    }
    
    gWebHostArr["private-api"] = urlApi;
    console.log("GetWebInfoAndUserSessionInfoFromServer param:" + urlApi + '  asyncCall:'+asyncCall);
    console.log(qs.stringify(data));
    //       httpAjax.ajax({
    //         url: urlApi,
    //         type: "POST",
    //         async: asyncCall,
    //         data: data,
    //         timeout: 3000,
    //         withCredentials: true,
    //         headers: {
    //            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
    //         },
    //         beforeSend: (xhr) => {
    //            // console.log("request show loading...");
    //         },
    //         success: function (result, status, xhr) {
    //             result = JSON.parse(result);

    return axios({
      method: "POST",
      url: urlApi,
      data: qs.stringify(data),
      timeout: 30000,
      withCredentials: true,
      headers: {},
    })
      .then(function (response) {
        if (response.data.ret != 200) {
          // v.$notify({
          //     message: "接口调用出错："+response.data.data.msg,
          //     offset: 100
          // });
          return false;
        }
        let result = response.data;
        //hosts
        gWebHostArr = result.data.hosts;

        //website
        gWebsiteSessionInfo.webSiteStyleTheme = result.data.website.style_theme;
        gWebsiteSessionInfo.webSiteLevel = result.data.website.web_level;
        gWebsiteSessionInfo.webSiteSchoolID = result.data.website.schoolid;
        gWebsiteSessionInfo.webSiteCityEduID = result.data.website.eduid_city;
        gWebsiteSessionInfo.webSiteCountyEduID =
          result.data.website.eduid_county;
        gWebsiteSessionInfo.webSiteEduID = result.data.website.eduid;
        gWebsiteSessionInfo.webSiteDocumentTitle = result.data.website.title;
        gWebsiteSessionInfo.webSiteTitle = result.data.website.space_name;
        gWebsiteSessionInfo.webSiteLogo = result.data.website.logo;
        gWebsiteSessionInfo.webSiteCityName = result.data.website.city_name; //如果不想显示连接，其值为空
        gWebsiteSessionInfo.webSiteCountyName = result.data.website.county_name; //如果不想显示连接，其值为空
        gWebsiteSessionInfo.webSiteSchoolName = result.data.website.school_name; //如果不想显示连接，其值为空

        gWebsiteSessionInfo.webSiteCityDomain = result.data.website.city_domain;
        gWebsiteSessionInfo.webSiteCountyDomain = result.data.website.county_domain;
        gWebsiteSessionInfo.webSiteSchoolDomain = result.data.website.school_domain;
        gWebsiteSessionInfo.webSiteICP = result.data.website.icp;
        gWebsiteSessionInfo.webSiteNeedLogin = result.data.website.need_login;

        //userinfo
        if (result.data.has_login) {
          gWebsiteSessionInfo.logined = true;
          gWebsiteSessionInfo.userid = result.data.userinfo.userid;
          gWebsiteSessionInfo.userIdentity = result.data.userinfo.identity;
          gWebsiteSessionInfo.userIdentityStatus =
            result.data.userinfo.identity_status;
          gWebsiteSessionInfo.userName = result.data.userinfo.username;
          gWebsiteSessionInfo.userFace = result.data.userinfo.userface;
          gWebsiteSessionInfo.userSchoolID = result.data.userinfo.schoolid;
          gWebsiteSessionInfo.userSchoolClassID = result.data.userinfo.classid;
          gWebsiteSessionInfo.userEduCityID = result.data.userinfo.edu_city;
          gWebsiteSessionInfo.userEduCountyID = result.data.userinfo.edu_county;
          gWebsiteSessionInfo.sessionKey = result.data.userinfo.token;
          gWebsiteSessionInfo.userAdminList = result.data.userinfo.admin_info;

          localStorage.setItem("loginUserID", gWebsiteSessionInfo.userid);
        }

        gWebsiteSessionInfo.hasInited++;

        return true;
      })
      .catch(function (error) {
        // 网络异常引发的错误
        console.log("GetWebInfoAndUserSessionInfoFromServer err="+error);
      });
    //,
    //error: (xhr, status, error) => {
    //    console.log("request error...");
    //    return false;
    //},
    //complete: (xhr, status) => {
    //   // console.log("request hide loading...");
    //}
    //});
  },

  //除了GetWebInfoAndUserSessionInfoFromServer，其他所有网络数据接口调用都通过本文件内post接口完成。
  post(data) {
    data = InitDefaultPostParams(data);
    data.userid =
      data.userid != undefined ? data.userid : gWebsiteSessionInfo.userid;
    data.token = gWebsiteSessionInfo.sessionKey;
    data.islocalNet = isInLocalNet();

    let api_url = this.GetWebHost("private-api");
    //console.log("post api_url:"+api_url);
    //console.log(qs.stringify(data));

    return axios({
      method: "post",
      url: api_url,
      data: qs.stringify(data),
      timeout: 30000,
      withCredentials: true,
      headers: {},
    })
      .then(function (response) {
        //console.log("post responose: s="+data.s+" \r\n data="+qs.stringify(response));
        if (response.data.ret != 200) {
          //  v.$notify({
          //      message: "接口调用出错："+response.data.data.msg,
          //      offset: 100
          //  });
          return false;
        }
        return response;
      })
      .catch(function (error) {
        // 网络异常引发的错误
        console.log("post err="+error);
      });
  },
  get(data) {
    data = InitDefaultPostParams(data);
    data.userid =
      data.userid != undefined ? data.userid : gWebsiteSessionInfo.userid;
    data.token = gWebsiteSessionInfo.sessionKey;
    data.islocalNet = isInLocalNet();

    let api_url = this.GetWebHost("private-api");
    return axios({
      method: "get",
      url: api_url,
      data,
      timeout: 30000,
      withCredentials: true,
      headers: {},
    })
      .then(function (response) {
          return response;
      })
      .catch(function (error) {
        // 网络异常引发的错误
        console.log("get err="+error);
      });
  },

  // 增加管理员日志
  async addOperationLog(req) {
    let org_id = gWebsiteSessionInfo.webSiteSchoolID;
    if (org_id == "" || org_id == "0" || org_id == 0) {
      org_id = gWebsiteSessionInfo.webSiteCountyEduID;
    }
    if (org_id == "" || org_id == "0" || org_id == 0) {
      org_id = gWebsiteSessionInfo.webSiteCityEduID;
    }

    const data = {
      s: "WebSchoolAdmin.AdminLog.addOperationLog",
      org_id: org_id,
      op_type: req.op_type,
      resource_type: req.resource_type,
      target_id: req.target_id,
      target_title: req.target_title,
      first_level_column: req.first_level_column,
      second_level_column: req.second_level_column,
    };
    let response = await this.post(data);

    return response;
  },

  getEduYunSpaceUrl(eduid) {
    if (gWebsiteSessionInfo.webSiteCityDomain != "") {
      return gWebsiteSessionInfo.webSiteCityDomain;
    }
    return this.GetWebHost("eduyun") + "home?edu_id=" + eduid;
  },
  getCountyEduYunSpaceUrl(eduid) {
    if (gWebsiteSessionInfo.webSiteCountyDomain != "") {
      return gWebsiteSessionInfo.webSiteCountyDomain;
    }
    return this.GetWebHost("eduyun") + "home?edu_id=" + eduid;
  },

  getSchoolSpaceUrl(schoolid) {
    if (gWebsiteSessionInfo.webSiteSchoolDomain != "") {
      return gWebsiteSessionInfo.webSiteSchoolDomain;
    }
    return this.GetWebHost("school") + "home?schoolid=" + schoolid;
  },

  getStudentSpaceUrl(userid) {
    return this.GetWebHost("student") + "home?userid=" + userid;
  },
  getTeacherSpaceUrl(userid) {
    return this.GetWebHost("teacher") + "home?userid=" + userid;
  },
  getResearcherSpaceUrl(userid) {
    return this.GetWebHost("researcher") + "home?userid=" + userid;
  },

  getSchoolClassSpaceUrl(classid) {
    return this.GetWebHost("class") + "home?classid=" + classid;
  },
  getVideoDetailUrl(videoid) {
    return this.GetWebHost("article") + "videoInfo?articleid=" + videoid;
  },

  // 跨域跳转 1=学校后台 2=资源详情 3=协作组 4=师生展评 5=学校空间  6=班级空间 7=学生空间 8=教师空间 9=教研员空间
  jumpPath(pathId, fileName = "", query = "") {
    let jumphost = "";
    if (pathId == 1) {
      jumphost = "school-admin";
    } else if (pathId == 2) {
      jumphost = "article";
    } else if (pathId == 3) {
      jumphost = "group";
    } else if (pathId == 4) {
      jumphost = "zhanping";
    } else if (pathId == 5) {
      jumphost = "school";
    } else if (pathId == 6) {
      jumphost = "class";
    } else if (pathId == 7) {
      jumphost = "student";
    } else if (pathId == 8) {
      jumphost = "teacher";
    } else if (pathId == 9) {
      jumphost = "researcher";
    }

    if (jumphost != "") {
      jumphost = this.GetWebHost(jumphost);
      window.open(jumphost + fileName + "?" + query);
    }
  },

  // 验证用户是否退出登录或者切换了用户，返回true表示用户已登录，false表示用户未登录
  async CheckLoginUserStatus() {
    if (!this.IsLogIned()) {
      return false;
    }
    const data = {
      s: "Common.WebTop.CheckLoginUserStatus",
    };
    const res = await this.post(data);
    const has_login = res.data.data.has_login;
    if (!has_login) {
      if (gWebsiteSessionInfo.userid > 1) {
        await this.loginOut();
      } else {
        this.clearLoginInfo();
      }
    }
    return has_login;
  },
  
  async CheckAndGotoLogin() {
      const is_login = await this.CheckLoginUserStatus();
      if (!is_login) {
          let fromurl = encodeURIComponent(window.location.href);
          window.location.href = this.GetWebHost("login") + '?fromurl=' + fromurl;
          return false;
      }
      return true;
  },

  async CheckLogin(calller) {
    if (!this.IsLogIned()) {
      let fromurl = encodeURIComponent(window.location.href);
      window.location.href = this.GetWebHost("login") + '?fromurl=' + fromurl;
    } else {
      const logined = await this.CheckLoginUserStatus();
      if (!logined) {
        calller
          .$confirm(
            "当前登录已过期！可能原因：<br/>1：登录超时.<br/>2：您的账号在其他地方登陆.<br/>如需修改密码，请使用终端进行操作。",
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
              dangerouslyUseHTMLString: true,
            }
          )
          .then(() => {
            calller.$router.go(0);
          })
          .catch(() => {
            calller.$router.go(0);
          });
        return false;
      } else {
        return true;
      }
    }
  },
  // 退出登录
  async loginOut() {
    this.clearLoginInfo();
    const data = {
      s: "Common.Account.loginOut",
    };
    await this.post(data);
  },
  // 退出登录时,清空数据
  clearLoginInfo() {
    localStorage.removeItem("loginUserID");

    gWebsiteSessionInfo.logined = false;
    gWebsiteSessionInfo.userid = 1;
    gWebsiteSessionInfo.userIdentity = 0;
    gWebsiteSessionInfo.userIdentityStatus = 0;
    gWebsiteSessionInfo.userName = "";
    gWebsiteSessionInfo.userFace = "";
    gWebsiteSessionInfo.userSchoolID = 0;
    gWebsiteSessionInfo.userSchoolClassID = 0;
    gWebsiteSessionInfo.userEduCityID = 0;
    gWebsiteSessionInfo.userEduCountyID = 0;
    gWebsiteSessionInfo.sessionKey = "";
  },

  // 检测资源阅读权限  1=有权 2=未登录 3=无权
  checkViewPower(permission_scope, schoolID, classID = 0) {
    // 验证资源权限e
    if (permission_scope == 1) {
      // 公开
      return 1;
    }

    // 验证是否登录
    if (gWebsiteSessionInfo.userid < 1000) {
      return 2;
    }
    // 验证权限
    if (permission_scope == 2) {
      // 本班
      if (
        schoolID == gWebsiteSessionInfo.userSchoolID &&
        (gWebsiteSessionInfo.userSchoolClassID == classID ||
          gWebsiteSessionInfo.userIdentity == 2)
      ) {
        return 1;
      } else {
        return 3;
      }
    } else if (permission_scope == 4) {
      // 本校
      return schoolID == gWebsiteSessionInfo.userSchoolID ? 1 : 3;
    } else if (permission_scope == 8) {
      // 本校教师
      if (
        schoolID == gWebsiteSessionInfo.userSchoolID &&
        (gWebsiteSessionInfo.userIdentity == 2 ||
          gWebsiteSessionInfo.userIdentity == 4)
      ) {
        return 1;
      } else {
        return 3;
      }
    }
  },

  // 获取当前学年学期
  // 9月1日-2月14日 上学期
  // 2月15日-8月31日 下学期
  getYearTerm() {
    var now = new Date();
    var now_year = now.getFullYear(); // 当前年份
    var now_month = now.getMonth() + 1; // 当前月份
    var now_day = now.getDate(); // 当前天
    var year, term;
    if (now_month == 2) {
      if (now_day <= 14) {
        year = now_year - 1;
        term = "1";
      } else {
        year = now_year;
        term = "2";
      }
    }
    if (now_month < 2) {
      year = now_year - 1;
      term = "1";
    }
    if (now_month >= 9) {
      year = now_year;
      term = "1";
    }
    if (now_month > 2 && now_month < 9) {
      year = now_year - 1;
      term = "2";
    }
    return { year, term };
  },

  // 生成随机数
  randomString(len) {
    len = len || 32;
    var i;
    var $chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz1234567890"; /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
    var maxPos = $chars.length;
    var pwd = "";
    for (i = 0; i < len; i++) {
      pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
    }
    return pwd;
  },

  //是否Android系统
  isAndroid() {
    var u = navigator.userAgent;
    var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //g
    return isAndroid;
  },

  //是否iOS系统
  isiOS() {
    var u = navigator.userAgent;
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    return isiOS;
  },

  checkLocalNet() {
    if (checkLocalInsideUrl != ""){  
        let checkUrl = checkLocalInsideUrl + "?tm=" + Date.parse(new Date());
        console.log("checkLocalNet,url=" + checkUrl);
        axios({
          method: "get",
          url: checkUrl,
          timeout: 3000,
          withCredentials: false,
          headers: {},
        })
          .then(function (response) {
            let content = response.data;

            if (content.indexOf(checkLocalInsideFlagStr) >= 0) {
              gWebsiteSessionInfo.isLocalNetInSide = "true";
              localStorage.setItem("isLocalNetInSide", "true");
            } else {
              localStorage.setItem("isLocalNetInSide", "false");
            }
          })
          .catch(function (error) {
            // 网络异常引发的错误
            console.log("checkLocalNet: " + error);
            gWebsiteSessionInfo.isLocalNetInSide = "false";
            localStorage.setItem("isLocalNetInSide", "false");
          });
    }
  },

  isLocalNet() {
    return isInLocalNet() == "true";
  },

  //传入要预览的文档url， 返回完整的 预览 地址
  getFileviewUrl(url) {
    let newurl = url;
    let host_from = this.GetWebHost("fileview-url-host");
    let host_replace_to = this.GetWebHost("fileview-url-host-replace");
    if (host_from && host_replace_to) {
      let arr_host = host_from.split(";");
      let arr_replace_to = host_replace_to.split(";");

      for (let i = 0; i < arr_host.length; i++) {
        if (url.indexOf(arr_host[i]) >= 0) {
          let r = parseInt(arr_host.length * Math.random());
          newurl = newurl.replace(arr_host[i], arr_replace_to[r]);
        }
      }
    }
    return this.GetRandOneWebHost("fileview") + encodeURI(newurl);
  },
  //文件校验（vue-simple-uploader）
  onChangeFile(mediainfo, param, that) {
    const file = param.file;
    var ext = file.name.split(".")[file.name.split(".").length - 1];
    if (ext == "mp4") {
      let format = false;
      if (file) {
        const getSize = () => file.size;
        const readChunk = (chunkSize, offset) =>
          new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = (event) => {
              if (event.target.error) {
                reject(event.target.error);
              }
              resolve(new Uint8Array(event.target.result));
            };
            reader.readAsArrayBuffer(file.slice(offset, offset + chunkSize));
          });

        mediainfo
          .analyzeData(getSize, readChunk)
          .then((result) => {
            format = result["media"]["track"][1].Format;
            let valid_format = format != "MPEG-4 Visual"; //格式效验通过
            if (!valid_format) {
              that.$message.error("文件效验失败，请转换视频文件编码格式！");
              param.cancel();
            }
          })
          .catch((error) => {
              console.log("onChangeFile analyzeData err: " + error);
            that.$message.error("文件效验失败，请转换视频文件编码格式！");
            param.cancel();
          });
      }
    }
  },
  //文件校验（element-ui）
  onChangeFileForElement(mediainfo, param, that) {
    const file = param.file;
    var ext = file.name.split(".")[file.name.split(".").length - 1];
    if (ext == "mp4") {
      let format = false;
      if (file) {
        const getSize = () => file.size;
        const readChunk = (chunkSize, offset) =>
          new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = (event) => {
              if (event.target.error) {
                reject(event.target.error);
              }
              resolve(new Uint8Array(event.target.result));
            };
            reader.readAsArrayBuffer(file.slice(offset, offset + chunkSize));
          });

        mediainfo
          .analyzeData(getSize, readChunk)
          .then((result) => {
            format = result["media"]["track"][1].Format;
            let valid_format = format != "MPEG-4 Visual"; //格式效验通过
            if (!valid_format) {
              that.$message.error("文件效验失败，请转换视频文件编码格式！");
              that.abort();
            } else {
              that.isDisabled = false; //校验通过允许，点击确定
            }
          })
          .catch((error) => {
              console.log("onChangeFileForElement analyzeData err: " + error);
            that.$message.error("文件效验失败，请转换视频文件编码格式！");
            that.abort();
          });
      }
    }
  },
};
